import './App.css';
import { MainView } from './components/mainView';

function App() {
    return (
        <MainView />
    );
}

export default App;